import { InclusionStatus } from "@/enum/list.enum";

import { ListPerson } from "../schema/list";

type BlacklistableLead = Pick<ListPerson, "inclusionStatus" | "blacklistType" | "prospect">;

/**
 * The lead unsubscribed from the caller's company: the API's `prospect.unsubscribed`, read from the
 * company's own unsubscribe entries. Never `prospect.sentiment`: that is the reply sentiment the
 * caller may see, and the shared column it used to be was written by any company's unsubscribe
 * (PREC-4826).
 */
const unsubscribedHere = (lead: BlacklistableLead): boolean => lead.prospect?.unsubscribed === true;

/**
 * A lead is "blacklisted" for outreach purposes when its list membership was blacklisted
 * (`inclusionStatus === BLACKLIST`, the same signal the API send-guard blocks on), it carries a
 * legacy `blacklistType`, or the prospect unsubscribed. Used to render the warning indicator and to
 * gate chat + campaign reassignment in the frontend (PREC-3728), keeping all three call sites in sync.
 */
export const isLeadBlacklisted = (lead?: BlacklistableLead | null): boolean =>
	!!lead &&
	(lead.inclusionStatus === InclusionStatus.BLACKLIST ||
		!!lead.blacklistType ||
		unsubscribedHere(lead));

/** True only when the block is specifically an unsubscribe (drives the "unsubscribed" wording). */
export const isLeadUnsubscribed = (lead?: BlacklistableLead | null): boolean =>
	!!lead && unsubscribedHere(lead);
